import React, { useMemo } from 'react';
import { View } from 'react-native';
import { sortListsAlphabetically } from '../utils';
import { List } from '../screens/Library/ListsScreen';

export default function UserLists({ navigation, lists, userId }) {
    const renderLists = useMemo(() => (
        sortListsAlphabetically(lists).map((list) => (
            <List 
                key={list.id} 
                list={list} 
                userId={userId}
                context='user'
                contextId={userId}
                navigation={navigation} />
        ))
    ), [lists]);
    return <View>{ renderLists }</View>
}